"use client";
import Tooltip from "@JohnLewisPartnership/jl-design-system/dist/components/tooltip/Tooltip";
import styles from "./ProductSpecificationSideDrawer.module.scss";
import { Attribute } from "../../../types/prodcatBaseTypes";
import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import { ListItem } from "@/components/__shared__/ListItem/ListItem.tsx";
import { ArrowRightOutlined as ArrowRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ArrowRightOutlined";
import { useState } from "react";
import { withSideDrawerAnalytics } from "@/components/ProductSideDrawers/withSideDrawerAnalytics.tsx";
type Props = {
  attributes: Attribute[];
  productType: string;
};

export const ProductSpecificationSideDrawerUI = ({
  attributes,
  productType,
}: Props) => {
  const [open, setOpen] = useState(false);

  if (productType === "RetiredStaticBundle") return null;

  return (
    <>
      <ListItem
        label="Product specification"
        onClick={withSideDrawerAnalytics("Product Specification", () =>
          setOpen(true),
        )}
        trailingIcon={<ArrowRight size="medium" />}
      />
      <Drawer
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
        heading="Product specification"
      >
        <dl
          data-testid="product:specification:list"
          className={styles.productSpecificationList}
        >
          {attributes.map((attribute, index) => (
            <ProductAttribute
              key={`attribute-${index}`}
              attribute={attribute}
            />
          ))}
        </dl>
      </Drawer>
    </>
  );
};

function ProductAttribute({ attribute }: { attribute: Attribute }) {
  return (
    <div className={styles.productSpecificationListItem}>
      <dd
        key={`${attribute.key}-label`}
        data-testid="product:specification:list:label"
        className={styles.productSpecificationListLabel}
      >
        <span className={styles.productSpecificationListLabelName}>
          {attribute.displayName}
        </span>
        {attribute.helpText && (
          <ProductAttributeToolTip
            helpText={attribute.helpText}
            toolTipId={attribute.key}
          />
        )}
      </dd>
      <dt
        key={`${attribute.key}-value`}
        data-testid="product:specification:list:value"
        className={styles.productSpecificationListValue}
      >
        {attribute.values?.join(", ")}
      </dt>
    </div>
  );
}

function ProductAttributeToolTip({
  helpText,
  toolTipId,
}: {
  helpText: string;
  toolTipId: string;
}) {
  return (
    <div
      data-testid="product:specification:list:label:tooltip"
      className={styles.productSpecificationListLabelToolTip}
    >
      <div className={styles.tooltipWrapper}>
        <Tooltip id={`tooltip-${toolTipId}`} icon verticalAnchor="top">
          {helpText}
        </Tooltip>
      </div>
    </div>
  );
}
